import React from 'react';

import { Box, Typography } from '@material-ui/core';

import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import styled from 'styled-components';

interface Props {
  title: string;
  value: number;
  subtitle: string;
  icon: React.ReactNode;
  color: string;
  bg: string;
  iconBg: string;
  disabled?: boolean;
}
const Card = styled.div<{ accent: string; bg: string }>`
  background: ${props => props.bg};
  border-radius: 16px;
  padding: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  position: relative;

  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);

  transition: 0.25s;

  cursor: pointer;

  &:hover {
    transform: translateY(-6px);

    box-shadow: 0 20px 36px rgba(0, 0, 0, 0.15);
  }

  &:before {
    content: '';

    position: absolute;

    left: 0;

    top: 0;

    width: 5px;

    height: 100%;

    background: ${({ accent }) => accent};
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  height: 100%;
`;

const IconCircle = styled.div<{ bg: string }>`
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.bg};

  svg {
    font-size: 24px;
  }
`;

const Sparkline = styled.div<{ color: string }>`
  width: 60px;
  height: 22px;
  position: relative;

  svg {
    stroke: ${props => props.color};
  }
`;

const formatValue = (value: number) => {
  if (value >= 1000000) return `${(value / 1000000).toFixed(2)}M`;

  if (value >= 1000) return `${(value / 1000).toFixed(2)}K`;

  return value.toLocaleString();
};

const KPICard = ({ title, value, subtitle, icon, color, bg, iconBg,  disabled = false, }: Props) => {
  return (
      <Card
        accent={color}
        bg={bg}
        style={{
          opacity: disabled ? 0.35 : 1,
          filter: disabled ? "grayscale(80%)" : "none",
         // border: !disabled ? `2px solid ${color}` : "2px solid transparent",
          boxShadow: !disabled
            ? "0 8px 24px rgba(0,0,0,.12)"
            : "none",
          transition: "all .25s ease",
          //transform: disabled ? "none" : "scale(1)",
          cursor: disabled ? 'none' : "pointer"
        }}
      >
        <Left>
        <Box display="flex" alignItems="center" gridGap={6}>
          <Typography
            variant="body2"
            style={{
              fontWeight: 600,
            }}>
            {title}
          </Typography>

          <InfoOutlinedIcon
            style={{
              fontSize: 14,
              color: '#808080',
            }}
          />
        </Box>

        <Typography
          style={{
            fontSize: 34,
            fontWeight: 700,
            color: disabled ? "#BDBDBD" : color,
          }}>
          {formatValue(value)}
        </Typography>

        <Typography variant="caption" color="textSecondary">
          {subtitle}
        </Typography>
      </Left>

      <Right>
        <IconCircle
          bg={disabled ? "#ECECEC" : iconBg}
        >
          {React.cloneElement(icon as React.ReactElement, {
            style: {
              ...(icon as React.ReactElement).props.style,
              color: disabled ? "#9E9E9E" : color,
            },
          })}
        </IconCircle>

        <Sparkline color={color}>
          <svg width="60" height="22" viewBox="0 0 60 22" fill="none">
            <path
              d="M2 18 L10 18 L18 14 L26 16 L34 11 L42 13 L50 5 L58 7"
              strokeWidth="2"
              fill="none"
            />
          </svg>
        </Sparkline>
      </Right>
    </Card>
  );
};

export default KPICard;
